import React from 'react';

import ConfirmationButton from '../../../app/components/ConfirmationButton';
import Button from '../../../common/components/Button';

interface SalesInvoicePositionsControlsProps {
  handleResetPositions: () => void;
  handleAddNewPosition: () => void;
  handleDeletePositions: (keys: number[]) => void;
  selected: number[];
  handleClonePosition: (key: number) => void;
  handleSave: () => void;
  handleCalculatePositions?: () => void;
  readOnly?: boolean;
  isLoading: boolean;
  hasLockedPositions?: boolean;
  hasExistingPositions?: boolean;
}

export const SalesInvoicePositionsControls: React.FC<
  SalesInvoicePositionsControlsProps
> = ({
  handleResetPositions,
  handleAddNewPosition,
  handleDeletePositions,
  selected,
  handleClonePosition,
  handleSave,
  handleCalculatePositions,
  readOnly,
  isLoading,
  hasLockedPositions,
  hasExistingPositions,
}) => {
  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex gap-1">
        {!readOnly && (
          <>
            <Button onClick={handleAddNewPosition} disabled={readOnly}>
              Nowa pozycja
            </Button>
            {selected.length === 1 && (
              <Button
                onClick={() => handleClonePosition(selected[0])}
                disabled={readOnly}
              >
                Klonuj pozycję
              </Button>
            )}
            {selected.length > 0 && (
              <ConfirmationButton
                variant="danger"
                onOK={() => handleDeletePositions(selected)}
                confirmation={`Czy na pewno chcesz usunąć zaznaczone pozycje (Lp: ${selected.join(', ')})?`}
                disabled={readOnly}
              >
                Usuń pozycje
              </ConfirmationButton>
            )}
            {!hasLockedPositions && (
              <ConfirmationButton
                variant="outline-danger"
                onOK={handleResetPositions}
                confirmation="Czy na pewno chcesz zresetować pozycje?"
                disabled={readOnly}
              >
                Resetuj pozycje
              </ConfirmationButton>
            )}
            {handleCalculatePositions && (
              <ConfirmationButton
                variant="outline-primary"
                onOK={handleCalculatePositions}
                confirmation={
                  hasExistingPositions
                    ? 'Wyliczenie pozycji zastąpi istniejące pozycje. Czy kontynuować?'
                    : 'Czy wyliczyć pozycje automatycznie na podstawie badań?'
                }
                disabled={readOnly}
              >
                Wylicz pozycje
              </ConfirmationButton>
            )}
          </>
        )}
      </div>
      <Button onClick={handleSave} disabled={isLoading} isLoading={isLoading}>
        {readOnly ? 'Dalej' : 'Zapisz i przejdź dalej'}
      </Button>
    </div>
  );
};
